import './preprocessFlowCompetition';
import { useMemo, useCallback, useEffect } from 'react';
import { InstancedFlow } from '../../common/CurveModifier';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import offsetAnimations from './competitionPathOffset.animations.json';
import animation from './flowCompetition.animation.json';
import {
  Color,
  DoubleSide,
  MeshStandardMaterial,
  AdditiveBlending,
} from 'three';

const offsets = Object.values(offsetAnimations);

const FlowPathOffsetter = ({
  index,
  animation,
  flowCompetition,
}) => {
  const onAnimation = useCallback((_, anim) => {
    const { animations } = anim;
    const [{ currentValue: offset }] = animations;
    flowCompetition.moveIndividualAlongCurve(index, offset);
  }, [index, flowCompetition]);

  return (
    <parallax.group
      beaker="chapter1"
      animation={ animation }
      onAnimation={ onAnimation }
    />
  );
};

export default function FlowCompetition({ curves }) {
  const pathextrude = useAsset('path_extrude');
  const extrudetex = useAsset('extrude_map');
  const material = useMemo(() => {
    return new MeshStandardMaterial({
      emissiveMap: extrudetex,
      emissive: new Color(0.22, 0.25, 0.27),
      color: new Color(0, 0, 0),
      blending: AdditiveBlending,
      side: DoubleSide,
      fog: false,
      transparent: true,
      depthWrite: false,
      depthTest: false,
      opacity: 1,
      toneMapped: false,
    });
  }, [extrudetex]);

  const flowCompetition = useMemo(() => {
    const { geometry } = pathextrude.nodes.Sweep;
    const instanceFlow = new InstancedFlow(4, 4, geometry, material);
    instanceFlow.object3D.renderOrder = 100;
    return instanceFlow;
  }, [pathextrude.nodes.Sweep, material]);

  useEffect(() => {
    curves.curves.forEach((curve, idx) => {
      flowCompetition.updateCurve(idx, curve);
      flowCompetition.setCurve(idx, idx);
    });
  }, [flowCompetition, curves]);

  return (
    <>
      { offsets.map((animation, idx) => (
        <FlowPathOffsetter
          key={ idx }
          index={ idx }
          animation={ animation }
          flowCompetition={ flowCompetition }
        />
      )) }
      <parallax.primitive
        beaker="chapter1"
        animation={ animation }
        object={ flowCompetition.object3D }
      />
    </>
  );
};